<template>
  <v-parallax
      style="width: 100%"
      height="300"
      src="@/assets/img/masas-artesanales-maquina.jpeg"
      class="parallax-gradient"

  >
    <v-overlay value="true" absolute>
      <v-row
          no-gutters
          align="center"
          justify="center"
          style="height: 100%"
      >
        <v-col
            class="text-center"
            cols="12"
        >
          <h1 class="text-h3 font-weight-thin mb-4 white--text">
            Masas Artesanales
          </h1>
        </v-col>
      </v-row>
    </v-overlay>

  </v-parallax>
</template>

<script>
export default {
  name: "HomeMasasArtesanales"
}
</script>

<style scoped>

</style>
